/**
 * True when `target` is inside a control that should handle its own activation
 * (so a parent row/card should not treat the event as a background click).
 * Uses `Element` (not `HTMLElement`) so SVG nodes inside icon buttons work with `closest()`.
 */
export function isEventTargetInsideInteractiveControl(
  target: EventTarget | null
): boolean {
  if (!(target instanceof Element)) {
    return false;
  }
  return Boolean(
    target.closest(
      'button, a, input, select, textarea, [role="button"], [role="link"]'
    )
  );
}
